import styled, {css} from 'styled-components'

export const StyledSkeletonSection = styled.section(
    ({theme: {palette}}) => css`
        border-radius: 6px;
        border: 1px solid ${palette.neutral[200]};
        overflow: hidden;
    `
)

export const StyledSkeletonSectionHeading = styled.div(
    ({theme: {spacing, palette}}) => css`
        background-color: ${palette.primary[50]};
        padding: ${spacing * 3}px;
    `
)

export const StyledSkeletonSectionBody = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 5}px ${spacing * 3}px;
    `
)
